import { render, staticRenderFns } from "./CreateAccountPropertyTargeting.vue?vue&type=template&id=38655b04&scoped=true"
import script from "./CreateAccountPropertyTargeting.vue?vue&type=script&lang=js"
export * from "./CreateAccountPropertyTargeting.vue?vue&type=script&lang=js"
import style0 from "./CreateAccountPropertyTargeting.vue?vue&type=style&index=0&id=38655b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38655b04",
  null
  
)

export default component.exports